import { API_CONFIG } from "./config";
import type { MarketAnalysisResponse } from "../pages/MarketAnalysis/types";

const AI_MARKET_SCANNER_BASE = "https://ai-market-scanner.crypsey.com";
const SCAN_ENDPOINT = "/scan";

export class MarketAnalysisService {
  /**
   * Fetch market analysis for a stock symbol via AI Market Scanner.
   * POST body: { symbol: "AAPL" }
   * @param symbol - Stock ticker (e.g. AAPL, MSFT)
   * @returns Promise<MarketAnalysisResponse>
   */
  static async getMarketAnalysis(symbol: string): Promise<MarketAnalysisResponse> {
    const trimmed = symbol.trim().toUpperCase();
    if (!trimmed) {
      throw new Error("Symbol is required");
    }
    const url = `${AI_MARKET_SCANNER_BASE}${SCAN_ENDPOINT}`;
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ symbol: trimmed }),
      signal: AbortSignal.timeout(API_CONFIG.TIMEOUT),
    });
    if (!response.ok) {
      const text = await response.text();
      let message = `Request failed (${response.status})`;
      try {
        const json = JSON.parse(text);
        if (json.message) message = json.message;
      } catch {
        if (text) message = text.slice(0, 200);
      }
      throw new Error(message);
    }
    const result = (await response.json()) as MarketAnalysisResponse;
    if (!result.ok || !result.data) {
      throw new Error("Invalid response from market analysis API");
    }
    return result;
  }
}
